module.exports = __webpack_public_path__ + "static/media/icon-close-gray.4fbad793.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-close-gray.svg
// module id = 662
// module chunks = 0